L.Icon.Default.imagePath = django_static_url +  'assets/lib/leaflet_libs/leaflet/images';
